var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { CiSearch } from "@react-icons/all-files/ci/CiSearch";
import { PiSlidersHorizontalThin } from "@react-icons/all-files/pi/PiSlidersHorizontalThin";
import { useFilterModal } from '../../context/FilterModalContext';
import { getFestivalOptions, getSelectedFilters } from '../../helpers/filter';
import history from '../../history';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
var defaultDestinationText = "Anywhere";
var defaultWeekText = "Anytime";
var FilterBar = function () {
    var destinations = useSelector(function (state) { return state.destinations.items; });
    var open = useFilterModal().open;
    var _a = useState(getSelectedFilters(history.location)), selectedFilters = _a[0], setSelectedFilters = _a[1];
    var allWeeks = destinations.reduce(function (acc, item) {
        var validWeeksForDestination = item.weeks;
        return __spreadArray(__spreadArray([], acc, true), validWeeksForDestination, true);
    }, []);
    useEffect(function () {
        var unlisten = history.listen(function () {
            setSelectedFilters(getSelectedFilters(history.location));
        });
        return function () {
            unlisten();
        };
    }, []);
    var countryFilter = selectedFilters.countryFilter, weekFilter = selectedFilters.weekFilter, festivalFilter = selectedFilters.festivalFilter, countOfFiltersSelected = selectedFilters.countOfFiltersSelected;
    var destinationText = defaultDestinationText;
    var weekText = defaultWeekText;
    if (countryFilter && countryFilter.length > 0) {
        destinationText = countryFilter[0] || "1 country";
        if (countryFilter.length > 1) {
            destinationText = "".concat(countryFilter.length, " countries");
        }
    }
    else if (festivalFilter && festivalFilter.length > 0) {
        var festivalOptions = getFestivalOptions(allWeeks);
        var selectedFestivalNames = festivalOptions.filter(function (festival) { return festival.weekIds.every(function (weekId) { return festivalFilter.includes("".concat(weekId)); }); }).map(function (festival) { return festival.name; });
        destinationText = "".concat(selectedFestivalNames.length, " festival").concat(selectedFestivalNames.length > 1 ? "s" : "");
    }
    if (weekFilter && weekFilter.length > 0) {
        weekText = "".concat(weekFilter.length, " week").concat(weekFilter.length > 1 ? "s" : "");
    }
    return (React.createElement("button", { className: 'dui-flex-shrink-0 dui-w-full md:dui-min-w-[450px] dui-text-left dui-bg-gray-100 dui-rounded-full dui-px-2 dui-py-2 dui-flex dui-items-center dui-gap-4 dui-cursor-pointer dui-justify-between', onClick: open },
        React.createElement("div", { className: 'dui-flex dui-items-center dui-gap-4' },
            React.createElement(CiSearch, { className: 'dui-text-2xl' }),
            React.createElement("div", null,
                React.createElement("p", { className: 'dui-text-xs sm:dui-text-sm dui-font-medium' }, "Where to?"),
                React.createElement("div", { className: 'dui-flex dui-items-center dui-gap-1 dui-text-gray-400' },
                    React.createElement("p", { className: "dui-text-xs sm:dui-text-sm ".concat(defaultDestinationText === destinationText ? "dui-text-gray-400" : "dui-text-primary-950 dui-font-semibold") }, destinationText),
                    React.createElement("p", { className: "dui-leading-none dui-font-bold dui-text-lg dui-text-primary-950" }, "\u00B7"),
                    React.createElement("p", { className: "dui-text-xs sm:dui-text-sm ".concat(defaultWeekText === weekText ? "dui-text-gray-400" : "dui-text-primary-950 dui-font-semibold") }, weekText)))),
        React.createElement("div", { className: "dui-relative dui-rounded-full dui-bg-white dui-p-2 sm:dui-ml-16 ".concat(countOfFiltersSelected ? "dui-border-solid dui-border-primary-950 dui-border-2" : "") },
            React.createElement(PiSlidersHorizontalThin, { className: 'dui-text-2xl' }))));
};
export default FilterBar;
